import React from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-sand/5">
      {/* Hero Section */}
      <div className="bg-wood text-sand py-16">
        <div className="container">
          <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-sand/90 max-w-2xl">
            This Privacy Policy describes how Sri GDM Interior Industries collects, uses, and
            protects your information.
          </p>
        </div>
      </div>

      <div className="container py-12">
        {/* Breadcrumb */}
        <div className="mb-8">
          <nav className="text-sm text-neutralText">
            <Link to="/" className="hover:text-wood">
              Home
            </Link>
            <span className="mx-2">/</span>
            <span className="text-wood">Privacy Policy</span>
          </nav>
        </div>

        <div className="prose max-w-none">
          <h2>Introduction</h2>
          <p>
            At Sri GDM Interior Industries, we take your privacy seriously. This privacy policy
            explains how we collect, use, and protect your personal information when you use our
            website or services.
          </p>

          <h2>Information We Collect</h2>
          <p>We collect information that you provide directly to us, including:</p>
          <ul>
            <li>Name and contact information</li>
            <li>Email address and phone number</li>
            <li>Project requirements and preferences</li>
            <li>Location and address details</li>
            <li>Communication history with our team</li>
          </ul>

          <h2>How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide and improve our interior design services</li>
            <li>Communicate with you about your projects</li>
            <li>Send updates about our services and promotions</li>
            <li>Process your requests and transactions</li>
            <li>Improve our website and customer service</li>
          </ul>

          <h2>Information Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information.
            However, no method of transmission over the internet is 100% secure, and we cannot
            guarantee absolute security.
          </p>

          <h2>Data Sharing</h2>
          <p>
            We do not sell or rent your personal information to third parties. We may share your
            information with:
          </p>
          <ul>
            <li>Service providers who assist in our operations</li>
            <li>Professional advisers and consultants</li>
            <li>Law enforcement when required by law</li>
          </ul>

          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of your information</li>
            <li>Opt-out of marketing communications</li>
          </ul>

          <h2>Cookies and Tracking</h2>
          <p>
            We use cookies and similar technologies to enhance your browsing experience and analyze
            website traffic. You can control cookie preferences through your browser settings.
          </p>

          <h2>Changes to This Policy</h2>
          <p>
            We may update this privacy policy from time to time. We will notify you of any changes
            by posting the new policy on this page and updating the effective date.
          </p>

          <h2>Contact Us</h2>
          <p>
            If you have questions about this privacy policy or our practices, please contact us at:
          </p>
          <address className="not-italic">
            Sri GDM Interior Industries
            <br />
            187 H, Kandigaiperi Rd
            <br />
            Valliyur, Tamil Nadu 627117
            <br />
            Phone: +91 98420 84477
            <br />
            Email: info@srigdminteriors.com
          </address>
        </div>
      </div>
    </div>
  );
}
